import _ from "lodash";
import { RESTAURANT_TAG } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        restaurantTag: _.cloneDeep(constants.TAG_INPUT)
    }
}

const restaurantTagReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RESTAURANT_TAG.SET_RESTAURANT_TAG_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case RESTAURANT_TAG.SET_RESTAURANT_TAG:
        case RESTAURANT_TAG.SET_RESTAURANT_TAG_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    restaurantTag: action.restaurantTag
                }
            })
        default:
            return state
    }
}

export default restaurantTagReducer